window.sendEvent = sendEvent;
window.sendEventC = sendEventC;
export function loadAnalyticsEvent() {
    const arrows = document.querySelectorAll('.project-card.project-card--mb .splide__arrow');
    arrows.forEach(arrow => {
        arrow.addEventListener('click', (event) => {
            var _a, _b;
            const text = (_b = (_a = arrow.getAttribute('aria-controls')) === null || _a === void 0 ? void 0 : _a.split('-')[0]) === null || _b === void 0 ? void 0 : _b.split('splide')[1];
            if (text) {
                const id_tiplogy = text;
                window.gtag("event", "slider_image", { tipology_id: id_tiplogy });
            }
        });
    });
}
setTimeout(() => {
    loadAnalyticsEvent();
}, 1000);
// Function to send events to Google Analytics
function sendEvent(typologyId, event) {
    let typologyIdGoogle = typologyId || event.target.getAttribute('value') || '';
    window.gtag("event", "join_group", { tipology_id: typologyIdGoogle });
}
function sendEventC(typologyId, event) {
    let typologyIdGoogle = typologyId || event.target.getAttribute('value') || '';
    window.gtag("event", "click_compare_card", { tipology_id: typologyIdGoogle });
}
